//
//
//
//
export default {
  name: "subjectC",
  props: ["childModules"],
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {},
  methods: {},
  watch: {},
  filters: {}
};